import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import {
  Button,
  Flex,
  Input,
  FormLabel,
  Stack,
  Text,
  FormControl,
  Select,
  useToast,
} from "@chakra-ui/react";
import { encrypt } from "../helpers/hash";
import { useNavigate, useParams } from "react-router-dom";
import Confirm from "./Confirm";
import RegistrationSuccess from "./RegistrationSuccess";
import { useCookies } from "react-cookie";
import EventCard from "./EventCard";
import LoadingPage from "./LoadingPage";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";

export default function FormRegistration({ event, loadingPage }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [openModal, setOpenModal] = useState(false);
  const [values, setValues] = useState({
    name: "",
    phoneNumber: "",
    origin: null,
  });
  const [cookies] = useCookies();
  const [imageUrl, setImageUrl] = useState("");
  const [registrationData, setRegistrationData] = useState({});

  useEffect(() => {
    setValues({
      ...values,
      name: cookies.user.name,
      phoneNumber: cookies.user.phoneNumber,
    });
    // eslint-disable-next-line
  }, []);

  function confirmation(e) {
    e.preventDefault();
    setOpenModal(!openModal);
  }

  async function generateQrCode() {
    const QRcontent = JSON.stringify({
      eventId: event._id,
      phoneNumber: values.phoneNumber,
    });
    try {
      const response = await QRCode.toDataURL(encrypt(QRcontent));
      const payload = {
        eventId: id,
        ...values,
        gender: cookies.user.gender,
        QR: response,
        origin: values.origin ? values.origin : "",
      };

      baseService.post(
        config.services.event.registration,
        payload,
        (res) => {
          setRegistrationData(res.data.data);
          toast({
            position: "top",
            description: `${res.data.message}`,
            status: "success",
            duration: 3000,
            size: "md",
            isClosable: true,
          });
          setImageUrl(response);
        },
        (err) => {
          toast({
            description: err.data.message,
            size: "10",
            position: "top",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div>
      {imageUrl ? (
        <RegistrationSuccess data={registrationData} />
      ) : loadingPage ? (
        <LoadingPage />
      ) : (
        <form onSubmit={confirmation}>
          <EventCard data={event} />
          <Stack
            spacing={4}
            p="1rem"
            backgroundColor="whiteAlpha.900"
            boxShadow="lg"
          >
            <FormControl>
              <FormLabel>Nama</FormLabel>
              <Input
                isRequired
                type="text"
                placeholder="Masukkan Nama Lengkap"
                name="name"
                value={cookies.user.name}
                disabled={cookies.user.name}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Nomor Handphone</FormLabel>
              <Input
                isRequired
                type="text"
                placeholder="Masukkan Nomor Handphone"
                name="phoneNumber"
                value={cookies.user.phoneNumber}
                disabled={cookies.user.phoneNumber}
              />
            </FormControl>

            {event && event.origin.length > 0 && (
              <FormControl isInvalid={values.origin === ""}>
                <FormLabel>Asal</FormLabel>
                <Select
                  isRequired
                  type="text"
                  placeholder="Pilih salah satu"
                  name="origin"
                  onChange={(e) =>
                    setValues({ ...values, origin: e.target.value })
                  }
                >
                  {event.origin.map((value, index) => {
                    return (
                      <option key={value} value={index}>
                        {value}
                      </option>
                    );
                  })}
                </Select>
                {values.origin === "" && (
                  <Text fontSize={13} color="red.500">
                    Asal wajib diisi.
                  </Text>
                )}
              </FormControl>
            )}
          </Stack>

          <Flex justifyContent="end">
            <Button
              mt={6}
              mr={3}
              onClick={() => navigate(-1)}
              colorScheme="gray"
            >
              Batal
            </Button>
            <Button mt={6} type="submit" colorScheme="blue">
              Daftar
            </Button>
          </Flex>
        </form>
      )}
      <Confirm
        content={{
          title: "Konfirmasi",
          desc: `Apakah anda yakin untuk mendaftar di ${event?.eventName}?`,
        }}
        active={openModal}
        onCancel={() => setOpenModal(!openModal)}
        callback={generateQrCode}
      />
    </div>
  );
}
